import * as plugins from '../../00plugins.js';
import * as colors from '../../00colors.js';

import {
  customElement,
  html,
  css,
  cssManager,
  DeesElement,
  property,
  unsafeCSS,
  query,
} from '@design.estate/dees-element';

import { demoFunc } from './dees-label.demo.js';
import { themeDefaultStyles } from '../../00theme.js';

@customElement('dees-label')
export class DeesLabel extends DeesElement {
  public static demo = demoFunc;
  public static demoGroups = ['Layout', 'Input'];

  // INSTANCE

  @property({
    type: String,
    reflect: true,
  })
  accessor label = '';

  @property({
    type: String,
    reflect: true,
  })
  accessor infoText!: string;

  @property({
    type: Boolean,
    reflect: true,
  })
  accessor required: boolean = false;

  public static styles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      /* TODO: Migrate hardcoded values to --dees-* CSS variables */
      :host {
        font-family: system-ui, 'Segoe UI', 'Roboto', sans-serif;
      }

      .label {
        display: inline-flex;
        align-items: center;
        color: var(--dees-color-text-primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 1.5;
        margin-bottom: 6px;
        cursor: default;
        user-select: none;
        letter-spacing: -0.01em;
      }

      .required {
        color: var(--dees-color-accent-error);
        margin-left: 2px;
      }

      .description-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        margin: -6px 0 -6px 2px;
        border-radius: 4px;
        cursor: default;
        transition: background 0.15s ease, color 0.15s ease;
        color: var(--dees-color-text-muted);
      }

      .description-icon:hover {
        background: var(--dees-color-active);
        color: var(--dees-color-text-secondary);
      }

      .description-icon dees-icon {
        font-size: 14px;
      }
    `,
  ];

  public render() {
    return html`
      ${this.label
        ? html`
            <div class="label">
              ${this.label}
              ${this.required ? html`<span class="required">*</span>` : ''}
              ${this.infoText
                ? html`
                    <div class="description-icon">
                      <dees-icon .icon=${'lucide:info'}></dees-icon>
                    </div>
                    <dees-speechbubble .text=${this.infoText}></dees-speechbubble>
                  `
                : html``}
            </div>
          `
        : html``}
    `;
  }
}
